import React, { useState } from 'react';
import './OverlayVistaAerea.css';

const OverlayVistaAerea = ({ onClose }) => {
  const [selectedArea, setSelectedArea] = useState(null);

  const areas = [
    {
      id: 'cancha',
      name: 'Cancha de Padel',
      img: process.env.PUBLIC_URL + '/imagenes/cancha.jpg',
      description: '',
      features: [
        'Cancha de padel profesional',
        'Iluminación nocturna',
        'Área de descanso',
        'Vista panorámica del desarrollo'
      ]
    },
    {
      id: 'parque',
      name: 'Parque y Áreas Verdes',
      img: process.env.PUBLIC_URL + '/imagenes/parque.jpg',
      description: '',
      features: [
        'Área de fogata',
        'Caminos peatonales iluminados',
        'Vegetación tropical',
        'Áreas de descanso'
      ]
    },
    {
      id: 'entrada',
      name: 'Entrada Principal',
      img: process.env.PUBLIC_URL + '/imagenes/entrada.jpg',
      description: '',
      features: [
        'Portería 24/7',
        'Control de acceso',
        'Diseño arquitectónico moderno',
        'Iluminación ornamental'
      ]
    }
  ];

  const handleAreaClick = (area) => {
    setSelectedArea(area);
  };

  const handleCloseArea = () => {
    setSelectedArea(null);
  };

  return (
    <div className="overlay-vistaaerea">
      <div className="overlay-vistaaerea-content">
        <div className="overlay-vistaaerea-left">
        <button className="overlay-back-btn" onClick={onClose}>
            <span className="material-symbols-outlined">arrow_back</span>
          </button>
          <img
            src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 1.png'}
            alt="Logo Garden"
            className="overlay-vistaaerea-logo"
          />
          <h1 className="overlay-vistaaerea-title">Exteriores</h1>
          <p className="overlay-vistaaerea-desc">
            Descubre todos los espacios y servicios que hacen de Garden un lugar único.<br />
            Explora cada área para conocer sus características especiales.
          </p>
        </div>
       
        <div className="overlay-vistaaerea-right">
          {/* Estructura original de PC */}
          <div className="areas-grid areas-grid-desktop">
            {areas.map((area) => (
              <div 
                key={area.id} 
                className="area-card"
                onClick={() => handleAreaClick(area)}
              >
                <img src={area.img} alt={area.name} className="area-img" />
                <div className="area-overlay">
                  <h3>{area.name}</h3>
                </div>
              </div>
            ))}
          </div>
          
          {/* Estructura móvil */}
          <div className="vistaaerea-header-fixed">
            <button className="overlay-back-btn" onClick={onClose}>
              <span className="material-symbols-outlined">arrow_back</span>
            </button>
            <img
              src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 1.png'}
              alt="Logo Garden"
              className="overlay-vistaaerea-logo-fixed"
            />
          </div>
          
          <div className="vistaaerea-scrollable-content">
            <h1 className="overlay-vistaaerea-title">Exteriores</h1>
            <p className="overlay-vistaaerea-desc">
              Descubre todos los espacios y servicios que hacen de Garden un lugar único.<br />
              Explora cada área para conocer sus características especiales.
            </p>
            
            <div className="areas-grid areas-grid-mobile">
              {areas.map((area) => (
                <div 
                  key={area.id} 
                  className="area-card"
                  onClick={() => handleAreaClick(area)}
                >
                  <img src={area.img} alt={area.name} className="area-img" />
                  <div className="area-overlay">
                    <h3>{area.name}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Modal moderno y compacto */}
      {selectedArea && (
        <div className="area-modal" onClick={handleCloseArea}>
          <div className="area-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="area-modal-close" onClick={handleCloseArea}>×</button>
            <div className="area-modal-header">
              <img src={selectedArea.img} alt={selectedArea.name} className="area-modal-img" />
              <div className="area-modal-title">
                <h2>{selectedArea.name}</h2>
              </div>
            </div>
            <div className="area-modal-body">
              <div className="area-features">
                <h3>Características principales</h3>
                <div className="features-grid">
                  {selectedArea.features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <span className="feature-icon">✓</span>
                      <span className="feature-text">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OverlayVistaAerea; 